import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";
import { NotificationProvider } from "./context/NotificationContext";
import ErrorBoundary from "./components/common/ErrorBoundary";
import Loader from "./components/common/Loader";
import LoginForm from "./components/forms/LoginForm";
import RegisterForm from "./components/forms/RegisterForm";
import Pms from "./pages/Pms";
import Archive from "./pages/Archive";
import Profile from "./pages/Profile";
import UserManagementPage from "./pages/UserManagement";
import Projects from "./pages/Projects";
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Bugs from './pages/Bugs';
import Sidebar from "./components/layout/Sidebar";
import "./App.css";

function App() {
  const { isAuthenticated, user, loading, login, logout } = useAuth();

  // Дополнительная проверка токенов при каждом рендере
  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    
    // Если нет токенов, но пользователь считается авторизованным, сбрасываем состояние--
    if (!token || !refreshToken) {
      if (isAuthenticated) {
        console.log("App.js: No tokens found, resetting authentication state");
        logout();
      }
    }
  }, [isAuthenticated, logout]);

  if (loading) {
    console.log('App.js: loading...');
    return <Loader text="Загрузка приложения..." size="large" />;
  }

  console.log('App.js: authenticated, rendering main app');

  return (
    <ErrorBoundary>
      <NotificationProvider>
        <div className="App flex">
          {isAuthenticated && <Sidebar onLogout={logout} />}
          <div className="flex-1">
            <Routes>
              <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginForm onLogin={login} />} />
              <Route path="/register" element={isAuthenticated ? <Navigate to="/" replace /> : <RegisterForm />} />
              <Route path="/" element={isAuthenticated ? <Pms user={user} onLogout={logout} /> : <LoginForm onLogin={login} />} />
              <Route path="/archive" element={isAuthenticated ? <Archive user={user} onLogout={logout} /> : <LoginForm onLogin={login} />} />
              <Route path="/profile" element={isAuthenticated ? <Profile /> : <LoginForm onLogin={login} />} />
              <Route path="/bugs" element={isAuthenticated ? <Bugs /> : <LoginForm onLogin={login} />} />
              <Route path="/users" element={isAuthenticated && user?.roles?.includes('ADMIN') ? <UserManagementPage /> : <LoginForm onLogin={login} />} />
              <Route path="/projects" element={isAuthenticated ? <Projects /> : <LoginForm onLogin={login} />} />
              <Route path="/settings" element={isAuthenticated && user?.roles?.includes('ADMIN') ? <Settings /> : <LoginForm onLogin={login} />} />
              <Route path="/analytics" element={isAuthenticated ? <Analytics /> : <LoginForm onLogin={login} />} />
            </Routes>
          </div>
        </div>
      </NotificationProvider>
    </ErrorBoundary>
  );
}

export default App;
